import React, { Fragment } from "react";
import useForm from "react-hook-form";
import { connect } from "react-redux";
import store from "store";
import ImageUpload from "./imageUpload";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { CountryList } from "../../../utlis/constant";

const ProductForm = (props) => {
  const { register, handleSubmit, errors } = useForm(); // initialise the hook
  var {
    info,
    onChangeUrl,
    searchProductUrl,
    searchUrlStatus,
    isEdit,
    imageUrl,
    onChangeImage,
    removeImage,
    onChangeSubCategory,
  } = props;
  console.log({ info });
  const onSubmit = (data) => {
    if (data !== "") {
      // onSubmitForm()/
      props.onClickConfirm(data);
    } else {
      errors.showMessages();
    }
  };

  return (
    <Fragment>
      <div className="container-fluid">
        <div className="card-body">
          <form
            id="product-form"
            className="needs-validation"
            noValidate=""
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              {/***** Name ******/}
              <div className="col-12 col-md-6 mb-3">
                <label className="mb-2">
                  Name
                  <span>*</span>
                </label>
                <input
                  className="form-control"
                  name="name"
                  type="text"
                  defaultValue={info.name}
                  placeholder="Name..."
                  ref={register({ required: true })}
                />
                <span>{errors.name && "Name is required"}</span>
              </div>

              {/****** Email *****/}
              <div className="col-12 col-md-6 mb-3">
                <label className="mb-2">
                  Email
                  <span>*</span>
                </label>
                <input
                  className="form-control"
                  name="email"
                  type="email"
                  defaultValue={info.email || ""}
                  placeholder="Email..."
                  ref={register({ required: true })}
                />
                <span>{errors.email && "Email is required"}</span>
              </div>

              {/******* Conatct Number ****/}
              <div className="col-12 col-md-6 mb-3">
                <label className="mb-2">
                  Contact Number
                  <span>*</span>
                </label>
                <input
                  className="form-control"
                  name="contactNumber"
                  type="number"
                  defaultValue={info.contactNumber}
                  placeholder="Contact Number..."
                  ref={register({ required: true })}
                />
                <span>
                  {errors.contactNumber && "contact number is required"}
                </span>
              </div>

              {/***** Role ****/}
              <div className="col-12 col-md-6 mb-3">
                <label className="mb-2">
                  Roll
                  <span>*</span>
                </label>{" "}
                <select
                  className="form-control btn-square"
                  name="accessLevel"
                  defaultValue={info.accessLevel || ""}
                  ref={register({ required: true })}
                >
                  <option value="0">--Select Roll--</option>
                  <option value={1}>{"Supper Admin"}</option>
                  <option value={2}>{"Admin"}</option>
                </select>
                <span>{errors.accessLevel && "Roll is required"}</span>
              </div>

              {/***** City *****/}
              <div className="col-12 col-md-6 mb-3">
                <label className="mb-2">
                  City
                  <span>*</span>
                </label>
                <input
                  className="form-control"
                  name="city"
                  type="text"
                  defaultValue={info.city}
                  placeholder="City..."
                  ref={register({ required: true })}
                />
                <span>{errors.city && "City is required"}</span>
              </div>

              {/***** Postal code *****/}
              <div className="col-12 col-md-6 mb-3">
                <label className="mb-2">
                  Postal Code
                  <span>*</span>
                </label>
                <input
                  className="form-control"
                  name="postalCode"
                  type="text"
                  defaultValue={info.postalCode}
                  placeholder="Postal Code..."
                  ref={register({ required: true })}
                />
                <span>{errors.postalCode && "Postal Code is required"}</span>
              </div>

              {/****** Country *******/}
              <div className="col-12 col-md-6 mb-3">
                <label className="mb-2">
                  Country
                  <span>*</span>
                </label>{" "}
                <select
                  className="form-control btn-square"
                  name="country"
                  defaultValue={info.country || ""}
                  ref={register({ required: true })}
                >
                  <option value="0">--Select Country--</option>
                  {CountryList.map((data) => {
                    return <option value={data.name}>{data.name}</option>;
                  })}
                </select>
                <span>{errors.country && "Country is required"}</span>
              </div>

              {/******** Address ********/}
              <div className="col-12 col-md-6 mb-3">
                <label className="mb-2">
                  Address
                  <span>*</span>
                </label>
                <input
                  className="form-control"
                  name="address"
                  type="text"
                  defaultValue={info.address}
                  placeholder="Address..."
                  ref={register({ required: true })}
                />
                <span>{errors.address && "Address is required"}</span>
              </div>
            </div>

            {/* <div className="form-row">
              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                  Name
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="name"
                    type="text"
                    defaultValue={info.name}
                    placeholder="Name..."
                    ref={register({ required: true })}
                  />
                  <span>{errors.name && "Name is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>
              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                  Email
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="email"
                    type="email"
                    defaultValue={info.email || ""}
                    placeholder="Email..."
                    ref={register({ required: true })}
                  />
                  <span>{errors.email && "Email is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>{" "}
              </div>
              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
                  Contact Number
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="contactNumber"
                    type="number"
                    defaultValue={info.contactNumber}
                    placeholder="Contact Number..."
                    ref={register({ required: true })}
                  />
                  <span>
                    {errors.contactNumber && "contact number is required"}
                  </span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>
              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                  Roll
                  <span>*</span>
                </label>{" "}
                <div className=" p-l-15 p-r-15">
                  <select
                    className="form-control btn-square"
                    name="accessLevel"
                    defaultValue={info.accessLevel || ""}
                    ref={register({ required: true })}
                  >
                    <option value="0">--Select Roll--</option>
                    <option value={1}>{"Supper Admin"}</option>
                    <option value={2}>{"Admin"}</option>
                  </select>
                  <span>{errors.accessLevel && "Roll is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>
              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
                  City
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="city"
                    type="text"
                    defaultValue={info.city}
                    placeholder="City..."
                    ref={register({ required: true })}
                  />
                  <span>{errors.city && "City is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>
              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
                  Postal Code
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="postalCode"
                    type="text"
                    defaultValue={info.postalCode}
                    placeholder="Postal Code..."
                    ref={register({ required: true })}
                  />
                  <span>{errors.postalCode && "Postal Code is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>
              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                  Country
                  <span>*</span>
                </label>{" "}
                <div className=" p-l-15 p-r-15">
                  <select
                    className="form-control btn-square"
                    name="country"
                    defaultValue={info.country || ""}
                    ref={register({ required: true })}
                  >
                    <option value="0">--Select Country--</option>
                    {CountryList.map((data) => {
                      return <option value={data.name}>{data.name}</option>;
                    })}
                  </select>
                  <span>{errors.country && "Country is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>

              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
                  Address
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="address"
                    type="text"
                    defaultValue={info.address}
                    placeholder="Address..."
                    ref={register({ required: true })}
                  />
                  <span>{errors.address && "Address is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>
            </div> */}

            <div className="p-15 float-end">
              <button className="btn btn-primary " type="submit" style={{ padding: "6px 28px", fontSize: "14px" }}>
                {isEdit ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};
export default connect()(ProductForm);
